import axios from 'axios';
import ApiService from '@api/api-service';
import haversine from 'haversine-distance';
import getHospitals from '@api/routes/findAHospital/findAHospital';
import * as submitSpinner from '../custom-forms/form-loading';
// import json from '../../../_patterns/01-components/Find-A-Hopsital/fah-mock-response.json';

var VCA = VCA || {};
// var mockData = json;

VCA.FindAHospitalUC = (function ($) {
    var ui = {};
    var _urlParams = {};

    function bindEvents() {
        ui.$viewMapBtn.on('click', focusOnMap);
        ui.$VMRForm.on('submit', validateForm);
    }

    function cacheUI() {
        ui.$filterPill = $('.filter-pills__pill');
        ui.$searchBtn = $('.find-search-btn');
        ui.$mapContainer = $("#FindAHospitalMap-UC");
        ui.$loadingSpinner = $('.search-results-container__loading');
        ui.$resultsContainer = $('.search-results-container__list');
        ui.$errorMsgContainer = $('.search-results-container__error-msg-container');
        ui.$errorMessage = $('.search-results-container__error-msg');
        ui.$viewMapBtn = $('[data-control="viewmap"]');
        ui.$searchValue = $('#SearchInput');
        ui.$searchRadius = $('#SearchRadius');
        ui.$zipcode = $('#zipcode').val();
        ui.$vwButtonText = $('#vwButtonText').val();
        ui.$tooltipIcon = $('#tooltipIcon').val();
        ui.$tooltipText = $('#tooltipText').val();
        ui.$searchRadiusUL = $('#SearchRadiusUL');
        ui.$defaultRadius = $('#defaultRadius').val();
        ui.$defaultLatitude = $("#defaultLatitude").val();
        ui.$defaultLongitude = $("#defaultLongitude").val();
        ui.$defaultFilter = $('.filter-pills__pill.active').attr('data-filter-value');
        ui.$countryId = $('#countryId').val();
        ui.$dataId = $('#dataId').val();
        ui.isCanada = $('[data-iscanada]').attr('data-iscanada');
        ui.$VWRInfoWrapper = $('.VWRInfoWrapper');
        ui.$VWRModal = $('#VWRFormModal');
        ui.$VWRFormSubmitBtn = $('#VWRFormSubmit');
        ui.$VMRForm = $('.uc-vwr-form');
        ui.$APIErrorMessage = $('.uc-vwr-modal__error-msg');
        ui.$VMRFormPhoneNum = $('#VWRPhoneNum');
        ui.$InputEl = $('.uc-vwr-modal input');
        ui.$SelectEl = $('.uc-vwr-modal select');
        ui.$TextAreaEl = $('.uc-vwr-modal textarea');
        ui.$map;
        ui.$geocoder;
        ui.$currentLat;
        ui.$currentLng;
        ui.$bounds;
        ui.$prevSearchValue;
        ui.$markers = [];
        ui.$selectedFiltersArr = [];

        ui.hospitalName;
        ui.hospitalId;
    }

    
    function initPage() {
        if ($('#FindAHospitalMap-UC').length <= 0) {
            return;
        }

        setCurrentDate();
        setSearchDefaultRadius();
        submitSpinner.setupLoadingSpinner(ui.$VWRFormSubmitBtn);

        ui.$geocoder = new google.maps.Geocoder();
        ui.$map = new google.maps.Map(document.getElementById('FindAHospitalMap-UC'), {
            center: new google.maps.LatLng(ui.$defaultLatitude, ui.$defaultLongitude),
            zoom: 12, //1 (furthest) to 20 (closest)
            minZoom:8 
        });

        ui.$currentLat = ui.$defaultLatitude;
        ui.$currentLng = ui.$defaultLongitude;

        var infoWindow = new google.maps.InfoWindow();

        if(ui.$zipcode){
            ui.$geocoder.geocode({
                'address': ui.$zipcode
            }, function (results, status) {
                if (status == 'OK') {
                    ui.$currentLat = results[0].geometry.location.lat();
                    ui.$currentLng = results[0].geometry.location.lng();
                    getSearchResults('Error: ', false);
                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                }
            });
        }else{
            getSearchResults('Error: ', false);
        }

        document.addEventListener('scroll', function () {
            if(isInViewport(ui.$resultsContainer)){
                ui.$viewMapBtn.addClass('-active');
            }else {
                ui.$viewMapBtn.removeClass('-active');
            }
        }, {
            passive: true
        });
    }

    

    function getFAHSearchParams() {

        let radiusValue = ui.$defaultRadius;
        ui.$bounds = getBounds(ui.$currentLat, ui.$currentLng, radiusValue);
        let minMaxValues = calcMinMaxLatLng(ui.$bounds);
        let fahSearchParams = {
            CurrentLat: ui.$currentLat,
            CurrentLng: ui.$currentLng,
            MinLatitude: minMaxValues.minLat,
            MaxLatitude: minMaxValues.maxLat,
            MinLongitude: minMaxValues.minLng,
            MaxLongitude: minMaxValues.maxLng,
            Radius: radiusValue,
            SearchText: null,
            HospitalType:  [
                "U"
            ],
            HospitalTypeDisplayName: null,
            Country: ui.$countryId,
            DataItemId: ui.$dataId
        }

        return fahSearchParams;
    }

    function focusOnMap() {
        $('html,body').animate({
            scrollTop: ui.$mapContainer.offset().top},
            'slow');
    }

    async function getSearchResults(errorMessage, blResetFilters) {
        ui.$resultsContainer.empty();
        ui.$resultsContainer.addClass('hidden');
        ui.$errorMsgContainer.addClass('hidden');
        ui.$loadingSpinner.removeClass('hidden');
        let fahSearchParams = getFAHSearchParams();
    
        
        ui.$bounds = getBounds(fahSearchParams.CurrentLat, fahSearchParams.CurrentLng, fahSearchParams.Radius);

        await getHospitals.post(fahSearchParams)
            .then(response => {
               // console.log('2',response);
               // console.log('3',response.data.OK);
                if (response.data.OK) {
                    let data = response.data.result;
                    let sortedData = sortResults(data);
                    removeMarkers();
                    createCard(sortedData);
                    ui.$loadingSpinner.addClass('hidden');
                    ui.$resultsContainer.removeClass('hidden');
                   // console.log('ui.$VWRInfoWrapper', ui.$VWRInfoWrapper);
                    $('.VWRInfoWrapper').on('click', showFormModal);
                    if (response.data.result.length === 0) {
                        showErrorMessage("No Results.");
                    }
                } else {
                    removeMarkers();
                    ui.$loadingSpinner.addClass('hidden');
                    showErrorMessage(response.data.error);
                }
            })
            .catch(error => {
                ui.$loadingSpinner.addClass('hidden');
                ui.$errorMsgContainer.removeClass('hidden');
                //handleLocationError(true, infoWindow, ui.$map.getCenter());
                console.log(errorMessage, error.response);
            });

    }

    function createCard(hospitals) {
        var bounds = new google.maps.LatLngBounds();

        for (var a = 0; a < hospitals.length; a++) {
            var hoursObj = hospitals[a].Hours;
            var parentContainer = $(document.createElement('li')).addClass('search-item');
            var leftContainer = $(document.createElement('a')).addClass('search-item__left -thumb js-hospital-dl-btn').attr('href', hospitals[a].Url ).css('background-image', `url(${hospitals[a].HospitalImageUrl})`);
            var rightContainer = $(document.createElement('div')).addClass('search-item__right -thumb');
            var descContainer = $(document.createElement('div')).addClass('search-item__desc-wrapper');
            var ctaContainer = $(document.createElement('div')).addClass('search-item__cta-container');
            var modalContainer = $(document.createElement('div')).addClass('hours-modal').attr({
                'id': `HoursModal-${a}`,
                'tab-index': '-1',
                'role': 'dialog'
            });
            var modalContentWrapper = $(document.createElement('div')).addClass('hours-modal__content modal-content').attr('role', 'document');
            var modalHoursWrapper = $(document.createElement('ul')).addClass('hours-modal__hours-list');

            // Calculate distance 
            var locationA = {
                latitude: hospitals[a].Latitude,
                longitude: hospitals[a].Longitude
            };
            var locationB = {
                latitude: ui.$currentLat,
                longitude: ui.$currentLng
            } //Need to modify this line of code
            var calcMiles = (haversine(locationA, locationB) * 0.000621371).toFixed(1);
            var distanceApart = `${calcMiles}`;

            // Create Google Map Markers 
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(hospitals[a].Latitude, hospitals[a].Longitude),
                map: ui.$map,
                animation: google.maps.Animation.DROP
            });

            ui.$markers.push(marker);

            var label = new google.maps.InfoWindow({
                content: hospitals[a].Name,
                maxWidth: 200
            });

            google.maps.event.addListener(marker, 'click', (function (marker, infowindow) {
                return function () {
                    infowindow.open(ui.$map, marker);
                };
            })(marker, label));
            bounds.extend(marker.getPosition());

            let waitTime = getTickToHours(hospitals[a].WaitTimes.waitingTimeInMinutes);

            // Create right section content
            var hospitalName = $(`<a class="search-item__header js-hospital-dl-btn" href="${hospitals[a].Url}">${hospitals[a].Name}</a>`);
            var waitingTimes = '';
            if(hospitals[a].WaitTimes.isOpen) {
                waitingTimes = $(`
                <div class="d-flex flex-row search-item__waitingTime__wrapper">
                <div class="search-item__waitingTime -open">
                    Estimated wait: ${waitTime}
                </div>
                <button class="uc-hero-panel__tooltip">
                    <img class="tooltip-icon" src="${ui.$tooltipIcon}" alt="Tooltip Icon">
                    <div class="uc-msg-tooltip -right">
                        <p>${ui.$tooltipText}</p>
                    </div>
                </button>
                </div>
            `);
            }else{
                waitingTimes = $(`
                <div class="search-item__waitingTime__wrapper">
                <div class="search-item__waitingTime -closed">
                    ${hospitals[a].WaitTimes.message}
                </div>
                </div>
            `);
            }
            var descContainerEl = $(`
                <div class="search-item__address"><span>${hospitals[a].AddressLine1} ${hospitals[a].AddressLine2}</span>&nbsp;<span>${hospitals[a].City}, ${hospitals[a].State} ${hospitals[a].Zipcode}</span></div>
                <div class="search-item__distance">
                    <button class="cta-tag hours-modal-btn">${hospitals[a].HoursLabel}</button>
                </div>
            `);

            var ctaContainerEl = $(`
                <div class="search-item__cta-tags">
                    <div class="cta-row">
                        <button
                            data-hospital-name="${hospitals[a].Name}"
                            data-toggle="modal"
                            data-target="VWRFormModal"
                            data-hospital-au="${hospitals[a].HospitalId}"
                            class="VWRInfoWrapper btn book-appointment ${hospitals[a].WaitTimes.isOpen == true && hospitals[a].WaitTimes.waitingTimeInMinutes !== null ? '' : 'hidden'}" href="#">${ui.$vwButtonText}</button>
                            <a class="redirect-to-map js-hospital-dl-btn ${hospitals[a].DirectionUrl == null || hospitals[a].DirectionUrl == '' ? 'hidden' : ''}" href="${hospitals[a].DirectionUrl}" target="_blank">
                                <img src="${hospitals[a].DirectionImageUrl}" alt="Direction Image">
                            </a>
                    </div>
                </div>  
            `);

            var hospitalLink = $(`
                <a class="search-item__link alt-fancy mt-3 js-hospital-dl-btn" href="${hospitals[a].Url}">Visit ${hospitals[a].Name}</a>
            `);

            rightContainer.append(hospitalName);
            rightContainer.append(waitingTimes);
            descContainer.append(descContainerEl);
            ctaContainer.append(ctaContainerEl);
            ctaContainer.append(hospitalLink);
            rightContainer.append(descContainer, ctaContainer);


            // Create Modal
            var modalBtnAndTitle = $(`
                <button type="button" class="hours-modal__close-btn close-btn" aria-label="close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="hours-modal__header">HOURS</div>
            `);

            var bottomModalSection = $(`
                <div class="hours-modal__divider"></div>
                <p class="hours-modal__message ${hospitals[a].HoursDisclaimer == null || hospitals[a].HoursDisclaimer == '' ? 'hidden' : ''}">*${hospitals[a].HoursDisclaimer}</p>
                <a class="hours-modal__link" href="${hospitals[a].HoursPageUrl}">View hospital info »</a>
            `);

            var currentDate = setCurrentDate();
            $.each(hoursObj, function (day, time) {
                modalHoursWrapper.append(`
                    <li class="${currentDate.toLocaleLowerCase() == day.toLocaleLowerCase() ? 'active' : ''}">
                        <span class="day">${day}</span>
                        <div class="time"><span>${time}</span><span class="hidden">*</span></div>
                    </li>
                `);
            });

            modalContainer.append(modalContentWrapper);
            modalContentWrapper.append(modalBtnAndTitle, modalHoursWrapper, bottomModalSection);
            parentContainer.append(leftContainer, rightContainer, modalContainer);
            ui.$resultsContainer.append(parentContainer);

            

            ui.$map.fitBounds(bounds);
        }

        //Bind events after dynamic content has been created
        ui.$modalBtn = $('.hours-modal-btn');
        ui.$hospitalDLPush = $('.js-hospital-dl-btn');
        ui.$closeBtn = $('.close-btn');
        ui.$modalBtn.on('click', openModal);
        ui.$hospitalDLPush.on('click', clickEventDL);
        ui.$closeBtn.on('click', closeModal);

        if(hospitals.length === 1)
        {
            ui.$map.setZoom(15);
        }

        if (hospitals.length === 0) {
            setDefaultMarker();
        }

    }

    function getTickToHours(time) {
        let num = time;
        let hours = (num / 60);
        let rhours = Math.floor(hours);
        let minutes = (hours - rhours) * 60;
        let rminutes = Math.round(minutes);

        if (rhours < 1) {
            return `${rminutes} minutes`;
        } else if (rhours == 1) {
            return `${rhours} hour and ${rminutes} minutes`;
        } else {
            return `${rhours} hours and ${rminutes} minutes`;
        }

    }

    function getBounds(lat, lng, radius) {
        let ConvertedRadius = radius * 1609.34;
        lat = parseFloat(lat);
        lng = parseFloat(lng);

        // add to canada site
         if(ui.isCanada === 'true'){
             ConvertedRadius = radius * 1000;
         }

        var circleData = {
            center: {
                lat,
                lng
            },
            radius: ConvertedRadius
        };

        if (window['google']) {
            return new window['google'].maps.Circle(circleData).getBounds();
        }
    }

    function calcMinMaxLatLng(bounds) {
        var obj = {
            minLat: bounds.getNorthEast().lat(),
            maxLat: bounds.getSouthWest().lat(),
            minLng: bounds.getNorthEast().lng(),
            maxLng: bounds.getSouthWest().lng()
        }
        return obj;
    }

    function closeModal(e) {
        e.stopPropagation();
        var parentEl = e.target.closest('.hours-modal');
        $(parentEl).css('display', 'none');
    }

    function showFormModal(e) {
        let el = $(e.target);
        let target = $(e.target)[0];

        if ($(target).hasClass('tooltip-icon') || $(target).hasClass('uc-hero-panel__tooltip')) {
            e.preventDefault();
            return;
        } else {
            ui.hospitalName = el.data('hospital-name');
            ui.hospitalId = el.data('hospital-au');
            loadIssueTypes();
            ui.$VWRModal.modal('show');

           // console.log('id', ui.hospitalName, ui.hospitalId);

           window.VCA.ucfahDatalayer.datalayerPushClick( 'hub-join vwr', ui.hospitalId);
        }

    }

 

    function handleLocationError(browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos);
        infoWindow.setContent(
            browserHasGeolocation ?
            "Error: The Geolocation service failed." :
            "Error: Your browser doesn't support geolocation."
        );
        infoWindow.open(ui.$map);
        ui.$loadingSpinner.addClass('hidden');
        showErrorMessage('Please provide address or zipcode.');
    }

    function isInViewport(el) {


        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }
        const rect = el.getBoundingClientRect();
        const mapRect = ui.$mapContainer[0].getBoundingClientRect();

        return (
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.bottom >= 0 &&
            mapRect.top >= (window.innerHeight - 200)
            );
    }

    function openModal(e) {
        e.stopPropagation();
        var parentContainer = e.target.closest('.search-item');
        var modal = $(parentContainer).find('.hours-modal');
        var hospitalAU = $(parentContainer).find('.VWRInfoWrapper').attr('data-hospital-au');
        $(modal).css('display', 'block');
        $(parentContainer).find('.hours-modal').find('.hours-modal__close-btn').trigger('focus');
        
        window.VCA.ucfahDatalayer.datalayerPushClick( 'hub-hours', hospitalAU);
    }

    function clickEventDL(e) {
        var parentContainer = e.target.closest('.search-item');
        var hospitalAU = $(parentContainer).find('.VWRInfoWrapper').attr('data-hospital-au');
        let action = 'hub-select hospital';
        if($(e.target).hasClass("redirect-to-map") || $(e.target).parent().hasClass("redirect-to-map")){
            action = 'hub-view map';
        }

        window.VCA.ucfahDatalayer.datalayerPushClick( action, hospitalAU);
    }

    function removeMarkers() {
        for (let i = 0; i < ui.$markers.length; i++) {
            ui.$markers[i].setMap(null);
        }
    }

    function setCurrentDate() {
        var dotw = '';
        switch (new Date().getDay()) {
            case 0:
                dotw = "Sun";
                break;
            case 1:
                dotw = "Mon";
                break;
            case 2:
                dotw = "Tues";
                break;
            case 3:
                dotw = "Wed";
                break;
            case 4:
                dotw = "Thurs";
                break;
            case 5:
                dotw = "Fri";
                break;
            case 6:
                dotw = "Sat";
        }

        return dotw;
    }

    function setDefaultMarker() {
        var currentLatLng = new google.maps.LatLng(ui.$defaultLatitude, ui.$defaultLongitude);
        var marker = new google.maps.Marker({
            position: currentLatLng,
            map: ui.$map,
            animation: google.maps.Animation.DROP,
            zoom: 8,
            center: currentLatLng
        });
    }

    function setSearchDefaultRadius() {
        ui.$searchRadius.val(ui.$defaultRadius);
        if(ui.isCanada === 'true'){
            $('.find-search__dropdown-btn').text(`${ui.$defaultRadius} KM`);
        }else{
            $('.find-search__dropdown-btn').text(`${ui.$defaultRadius} miles`);
        }
        var radiusOnLoad = $('.find-search__dropdown-list').find(`[data-value="${ui.$defaultRadius}"]`)[0];
        $(radiusOnLoad).addClass('focused selected');
    }

    function showErrorMessage(errorMessage) {
        ui.$errorMessage.text(errorMessage);
        ui.$errorMsgContainer.removeClass('hidden');
    }

    function sortResults(data) {
        var results = [...data];
        $(results).each(function () {
            var hospLat = this.Latitude;
            var hospLng = this.Longitude;
            var setA = {
                latitude: hospLat,
                longitude: hospLng
            };
            var setB = {
                latitude: ui.$currentLat,
                longitude: ui.$currentLng
            }
            var miles = (haversine(setA, setB) * 0.000621371).toFixed(1);
            this.miles = Number(miles);
        });
        var sortedArray = results.sort(function (a, b) {
            return a.miles - b.miles
        });
        return sortedArray;
    }

    
    function validateForm(evt) {
        evt.preventDefault();
        ui.$APIErrorMessage.hide();
        submitSpinner.startLoadingSpinner(ui.$VWRFormSubmitBtn);

        if (!checkForm()) {
            submitSpinner.stopLoadingSpinner(ui.$VWRFormSubmitBtn);
            return;
        } else  {
            initPostForm();
        }
    }

    function checkForm() {
        let phoneReg = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        let valid = true;

        $('.uc-vwr-form input').each(function (index) {
            let el = $(this);
            var elmId = el.attr('id');

            if (elmId == 'VWRPhoneNum') {
                let phone = ui.$VMRFormPhoneNum.val();
                if (!phoneReg.test(phone)) {
                    ui.$VMRFormPhoneNum.addClass('error');
                    ui.$VMRFormPhoneNum.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    ui.$VMRFormPhoneNum.removeClass('error');
                    ui.$VMRFormPhoneNum.closest('.form-label-group').removeClass('error');
                }
            } else {
                if (el.val() == '') {
                    el.addClass('error');
                    el.closest('.form-label-group').addClass('error');
                    valid = false;
                } else {
                    el.removeClass('error');
                    el.closest('.form-label-group').removeClass('error');
                }
            }
        });
        $('.uc-vwr-form select').each(function (index) {
            let el = $(this);
            if (el.val() == '' || el.val() == null) {
                el.addClass('error');
                el.closest('.form-label-group').addClass('error');
                valid = false;
            } else {
                el.removeClass('error');
                el.closest('.form-label-group').removeClass('error');
            }
        });

        $('.uc-vwr-form textarea').each(function (index) {
            let el = $(this);
            if (el.val() == '' || el.val() == null) {
                el.addClass('error');
                el.closest('.form-label-group').addClass('error');
                valid = false;
            } else {
                el.removeClass('error');
                el.closest('.form-label-group').removeClass('error');
            }
        });
        return valid;
    }

    async function initPostForm() {
        const url = '/urgentcare-api/virtualline/waitlistQueueRequest';
        let api = new ApiService(url);

        let $FirstName = ui.$VMRForm.find('#VWRFirstName').val();
        let $LastName = ui.$VMRForm.find('#VWRLastName').val();
        let $PetName = ui.$VMRForm.find('#VWRPetName').val();
        let $PetSpecies = ui.$VMRForm.find('#VWRPetSpecies').val();
        let $IssueType = ui.$VMRForm.find('#VWRIssueType').val();
        let $PhoneNum = ui.$VMRForm.find('#VWRPhoneNum').val();
        let $Description = ui.$VMRForm.find('#VWRBriefDesc').val();

        let payload = {
            "firstName": $FirstName,
            "lastName": $LastName,
            "petName": $PetName,
            "speciesType": $PetSpecies,
            "issueTypeId": $IssueType,
            "phoneNumber": $PhoneNum,
            "briefDesc": $Description,
            'hospitalName': ui.hospitalName,
            'hospitalId': ui.hospitalId
        }

     //   console.log('payload', payload);
        
        const searchParams = params => Object.keys(params).map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
            
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }

        const { data, success, error } = await api.post(searchParams(payload), axiosConfig);

        if (success) {
            if (data.success) {
                let hospitalName = ui.$VWRInfoWrapper.data('hospital-name');

                //google analytics
                window.dataLayer.push({
                    event:'clickevent',
                    category:'vca urgent care',
                    action:'join vwr success',
                    label: hospitalName
                });

                window.location.href = data.dataRedirect;
            } else {
                if (data.errorMessage !== null || data.errorMessage !== '') {
                    ui.$APIErrorMessage.find('.vwr-form-errormsg').text(data.errorMessage);
                    ui.$APIErrorMessage.show();
                    submitSpinner.stopLoadingSpinner(ui.$VWRFormSubmitBtn);
                }
            }
        } else {
            ui.$APIErrorMessage.find('.vwr-form-errormsg').text(error);
            ui.$APIErrorMessage.show();
            submitSpinner.stopLoadingSpinner(ui.$VWRFormSubmitBtn);
            console.log(`Virtual Waiting Room Form API Error: ${error}`);
        }
    }

    async function loadIssueTypes() {
        const url = `/urgentcare-api/virtualline/issuetypes?id=${ui.hospitalId}`;
        let api = new ApiService(url);

        const { data, success, error } = await api.get();

        if (!success || (error !== null && error !== '')) {
            console.log("API Issue Type Error: ", error);
        } else { 
            let results = data;

            if (results == null || results == undefined) {
                console.log("Error: API results are empty, null, or undefined.");
            } else {
                //SUCCESS
                $('#VWRIssueType').html('<option selected="" disabled="" hidden=""></option>');
                $(results).each((idx,item) => {
                    let option = `<option value="${item.issueTypeId}" data-mapping-id="${item.issueMappingId}">${item.issueTypeName}</option>`;
                    $('#VWRIssueType').append(option);
                });
            }
        }
    }

    function init() {
        if ($('#defaultRadius').length <= 0) {
            return;
        }
        cacheUI();
        bindEvents();
        initPage();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {

    if ($('#FindAHospitalMap-UC').length <= 0) {
        return;
    }
    //check for hiding left arrow in filter pills carousel
    let primaryFilter = $('.filter-pills').find('.slick-slide')[0];
    let leftArrowBtn = $('.filter-pills').find('.slick-prev.slick-arrow');
    let primaryIsSelected = $(primaryFilter).hasClass('slick-active');
    if (primaryIsSelected) {
        $(leftArrowBtn).hide();
    }

    $('.slick-prev').on('click', function (event) {
        event.preventDefault();
        primaryFilter = $('.filter-pills').find('.slick-slide')[0];
        primaryIsSelected = $(primaryFilter).hasClass('slick-active');

        if (primaryIsSelected) {
            $(leftArrowBtn).hide();
        }
    });

    $('.slick-next').on('click', function (event) {
        event.preventDefault();
        $(leftArrowBtn).show();
    });

    const mapEl = document.getElementById('FindAHospitalMap-UC');

    function checkForGoogleMapsUC() {
        setTimeout(() => {
            if('google' in window && typeof google === 'object' && typeof google.maps === 'object' && mapEl){
                console.log('google', google);
                VCA.FindAHospitalUC.init(mapEl);
            }
            else {
                checkForGoogleMapsUC();
            }
        }, 1000);
    }

    checkForGoogleMapsUC();
});